import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { ProfileEntity, searchUserParams } from '@interpals/api-web';

import api from 'api';
import { ReduxState } from '../root-reducer';

import { PeopleSearchFilters } from './reducer';

const PAGE_LIMIT = 10;
// Kilometers
export const NEARBY_RADIUS = 50;

interface SearchPeopleParams {
    filters: PeopleSearchFilters;
    offset?: number;
}

export const getSearchUserParams = (filters: PeopleSearchFilters): searchUserParams => {
    return {
        sex: filters.sex,
        countries: filters.countries,
        home_countries: filters.home_countries,
        city: filters.city ? (filters.city?.value as string) : undefined,
        continents: filters.continents,
        home_city: filters.home_city?.map((city) => city.value).join(),
        age1: Number(filters.age1) || undefined,
        age2: Number(filters.age2) || undefined,
        lfor_langex: filters.lfor?.some((rule) => rule === 'lfor_langex') || undefined,
        lfor_meet: filters.lfor?.some((rule) => rule === 'lfor_meet') || undefined,
        lfor_friend: filters.lfor?.some((rule) => rule === 'lfor_friend') || undefined,
        lfor_relation: filters.lfor?.some((rule) => rule === 'lfor_relation') || undefined,
        lfor_snail: filters.lfor?.some((rule) => rule === 'lfor_snail') || undefined,
        known: filters.known,
        knownlevelmin: filters.knownlevelmin,
        learn: filters.learn,
        text: filters.username,
        online: filters.online,
        new: filters.new,
        limit: PAGE_LIMIT,
        photo: filters.photo,
        sort: filters.sort || 'last_login',
        tag_ids: filters.tag_ids?.map((item) => item.value).join(','),
        location: filters.location,
        radius: filters.radius ?? NEARBY_RADIUS,
    };
};

export const searchPeople = createAsyncThunk<ProfileEntity[], SearchPeopleParams, { state: ReduxState }>(
    'people/search',
    async ({ filters, offset }) => {
        return api
            .searchUser({
                ...getSearchUserParams(filters),
                offset,
            })
            .then(({ data }) => {
                return data;
            });
    },
);

export const setPeopleIsLoading = createAction<boolean>('set/people/loading');
export const setPeopleFilters = createAction<PeopleSearchFilters>('people/filters/set');
export const resetFilters = createAction('people/filters/reset');
export const clearPeople = createAction('people/clear');
